import script from "./UpdateFirmwareModel.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateFirmwareModel.vue?vue&type=script&setup=true&lang=js"

import "./UpdateFirmwareModel.vue?vue&type=style&index=0&id=343a876d&lang=less"

const __exports__ = script;

export default __exports__